import { render, staticRenderFns } from "./Instructor.vue?vue&type=template&id=69225786&scoped=true"
import script from "./Instructor.vue?vue&type=script&lang=js"
export * from "./Instructor.vue?vue&type=script&lang=js"
import style0 from "./Instructor.vue?vue&type=style&index=0&id=69225786&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69225786",
  null
  
)

export default component.exports